module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(0), _c('div', {
    staticClass: "nav"
  }, [_c('h4', [_vm._v("Menu")]), _vm._l((_vm.pages), function(page) {
    return _c('ul', {
      staticClass: "list"
    }, [_c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.changePage(page)
        }
      }
    }, [_vm._v(_vm._s(page))])])])
  })], 2), _c('div', {
    staticClass: "blog"
  }, [_c('h4', [_vm._v("Recent posts")]), _vm._l((_vm.posts), function(val, key) {
    return _c('ul', {
      staticClass: "list"
    }, [_c('li', {
      staticClass: "post"
    }, [_c('a', [_vm._v(_vm._s(key))]), _c('div', {
      staticClass: "post-data"
    }, [_vm._v(_vm._s(val))])])])
  })], 2), _c('div', {
    staticClass: "contact"
  }, [_c('h4', [_vm._v("Contact us")]), _c('p', [_vm._v("2426 Sing Street,")]), _c('p', [_vm._v("Quesnel BC,")]), _c('p', [_vm._v("V2J 4P7, Canada.")]), _c('ul', {
    staticClass: "list social-list"
  }, _vm._l((_vm.socials), function(social) {
    return _c('li', {
      staticClass: "social-item"
    }, [_c('a', {
      staticClass: "social-link"
    }, [_c('img', {
      attrs: {
        "src": require("../assets/icons/" + social + ".svg")
      }
    })])])
  }))])]), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('a', {
    staticClass: "logo-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.svg")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyright"
  }, [_c('p', [_vm._v("Developed by pxlhead. All rights reserved. ®")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-61dfd822"}!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainFooter.vue
// module id = 130
// module chunks = 0